import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {filter, mergeMap, switchMap, tap} from 'rxjs/operators';
import {of} from 'rxjs';
import * as GlobalActions from './global.actions';
import {Store} from '@ngrx/store';
import {selectIsConfigLoaded} from './global.selectors';
import {pubmaticBuyersLoaded} from '../segment/info/shared-targets-list/account-pubmatic/pubmatic-state';
import {loadAllTaxonomiesSuccess} from '../taxonomy/taxonomy.actions';
import {
  brandsLoaded,
  categoriesLoaded,
  segmentAudienceTypesLoaded,
  segmentMainTypesLoaded,
  segmentSubTypesLoaded
} from '../filters-config/filters-config.actions';
import {userSet} from '../app.types';


@Injectable()
export class GlobalEffects {

  loadGlobals$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GlobalActions.tryLoadInitialConfig, userSet),
      mergeMap((event) =>
        this.store
          .select(selectIsConfigLoaded)
          .pipe(
            tap(console.log),
            filter(isLoaded => !isLoaded),
            switchMap(_ => of(GlobalActions.loadInitialConfig())))
      )
    );
  });
  configLoaded$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(pubmaticBuyersLoaded,
        loadAllTaxonomiesSuccess,
        segmentAudienceTypesLoaded,
        segmentSubTypesLoaded,
        segmentMainTypesLoaded,
        brandsLoaded,
        categoriesLoaded),
      mergeMap((event) => of(GlobalActions.initialConfigLoaded()))
    );
  });


  constructor(private actions$: Actions, private store: Store) {
  }
}
